"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDraw(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm16 1.976a.66761.66761 0 0 1 -.208.52l-.936.936-2.236-2.34.936-.884a.754.754 0 0 1 1.04 0l1.3 1.3a1.24187 1.24187 0 0 1 .104.468zm-3.744-.52-4.576 4.576v2.288h2.288l4.576-4.576zm-2.6 6.136h-.5755v-.728h-.728v-.5755l.52-.52 1.3035 1.3035zm-.104-2.0314c-.0555.0554-.0485.0554-.104.0554s-.104 0-.104-.104a.201.201 0 0 1 .0485-.104l2.9675-2.9605c.0485-.0555.0485-.0555.104-.0555.0554 0 .104 0 .104.104a.201.201 0 0 1 -.0485.104zm-8.6674 9.5775a.506.506 0 0 1 -.2075-.0449.50082.50082 0 0 1 -.2466-.6631c.4146-.9082 1.541-.8506 2.5317-.8037.6431.0322 1.4414.0703 1.5737-.2207.1328-.291-.4199-.8691-.8638-1.333-.687-.7188-1.4653-1.5322-1.0503-2.4404.4142-.9083 1.5387-.8536 2.5314-.8018.6406.0332 1.439.0723 1.5723-.2188a.4999.4999 0 1 1 .9091.4161c-.414.9072-1.5381.8525-2.5312.8017-.6406-.0322-1.439-.0723-1.5723.2188-.1328.291.4199.8691.8638 1.333.687.7178 1.4653 1.5322 1.0503 2.4404s-1.5425.8496-2.5317.8037c-.6431-.0322-1.4404-.0693-1.5737.2207a.5001.5001 0 0 1 -.4552.292z' })));
}
exports.default = SvgDraw;
